<template>
    <div id="form-container" ref="formContainer">
        <b-container fluid>
            <h1>Register Provider Account</h1>
            <b-row>
              <b-col>
                <p>This page is for registering provider administrator accounts, limited to one account per facility. At this time, only nursing homes and certified boarding care homes may register to submit staff reporting.</p>
                <p>Only the facility's Administrator or Authorized Agent may create the provider account using the registration key code. Once the account is registered, the Administrator or Authorized Agent may add additional users (e.g. Clinical Nursing Direcdtor, HR staff).</p>
                <p>Please enter the required information below to proceed.</p>
              </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <p>
                        Please enter the following information.
                    </p>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h2>
                        Information
                    </h2>
                </b-col>
            </b-row>
            <b-row align-v="center">
                <b-col cols="4">
                    <BaseTextInput v-model="registration.hfid"
                                   :v="$v.registration.hfid"
                                   slug="HFID"
                                   label="HFID"
                                   :plaintext="showRegistrationForm"
                    />
                </b-col>
                <b-col cols="4">
                    <b-button @click="search">Search</b-button>
                </b-col>
            </b-row>
                <div v-if="showResult">
                    <b-row>
                        <b-col>
                            <h2>Confirm facility:</h2>
                        </b-col>
                    </b-row>
                    <div v-for="(provider, index) in providers" :key="index">
                        <b-row>
                            <b-col cols="4">
                                <BaseTextOutput label="HFID" :value="provider.hfid"/>
                            </b-col>
                            <b-col cols="4">
                                <BaseTextOutput label="Name" :value="provider.name"/>
                            </b-col>
                            <b-col cols="4">
                                <BaseTextOutput label="Provider Type" :value="provider.type"/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="3">
                                <BaseTextOutput label="Street Address" :value="provider.streetAddress"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="City" :value="provider.city"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="State" :value="provider.state"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="Zip Code" :value="provider.postalCode"/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-button variant="primary" @click="choiceYes(provider)">Yes</b-button>
                                <b-button variant="danger" @click="choiceNo">No</b-button>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            <br/>
                <div v-if="showRegistrationForm">
                    <b-row align-v="center">
                        <b-col cols="4">
                            <BaseTextInput v-model="registration.registrationKey"
                                           :v="$v.registration.registrationKey"
                                           slug="registrationKey"
                                           label="Registration Key"/>
                        </b-col>
                        <b-col cols="4">
                            <b-button variant="primary" @click="showResendModal">Resend registration key</b-button>
                        </b-col>
                    </b-row>
                <b-row>
                    <b-col>
                        <b-button type="button" variant="primary" @click="register">Register</b-button>
                    </b-col>
                </b-row>
                </div>

            <b-modal id="resend-modal" hide-header hide-footer>
                <h2>Resend verification code?</h2>
                <p>Click confirm to resend the registration code for {{selected.name}} to the email on file, or click cancel to go back.</p>
                <p>If you have questions please contact support at
                    <a href="mailto:health.fpc-nar@state.mn.us">health.fpc-nar@state.mn.us</a>.</p>
                <div>
                    <b-button @click="resendRegistrationKey">Confirm</b-button>
                    <b-button @click="hideResendModal">Cancel</b-button>
                </div>
            </b-modal>
        </b-container>
    </div>
</template>

<script>
    import axios from 'axios';
    import axiosRetry from 'axios-retry';
    import BaseTextInput from "@/components/templates/input/BaseTextInput";
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import {toastService} from "@/mixins/toastService";
    import {required, sameAs, email} from 'vuelidate/lib/validators';



    axiosRetry(axios, { retries: 0,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        data(){
            return{
                registration:{
                    hfid: null,
                    providerType: null,
                    registrationKey: null,
                },
                providers: [{
                    hfid: null,
                    name: null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    postalCode: null,
                }],
                selected: {
                    name: null,
                    id: null
                },
                showResult: false,
                showRegistrationForm: false,
            }
        },
        components:{
            BaseTextInput,
            BaseTextOutput
        },
        methods:{
            register(){
                this.$v.$touch();
                if(this.$v.$invalid){
                    this.$nextTick(()=>{
                        document.getElementById('form-container').scrollIntoView();
                    })
                    return;
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/provider/register/admin`,
                    {
                        facilityId: this.registration.hfid,
                        providerType: this.registration.providerType,
                        registrationKey: this.registration.registrationKey
                    }
                )
                    .then(response =>{
                        if(response.status===200){
                            toastService.showRootToast("Success", "You have registered your account.", "success", this.$root)
                            setTimeout( () => this.$router.push({ path: '/home'}), 10000);
                        }
                    }).catch(error=>{
                        if(error.response.status===401) {
                            toastService.showRootToast("Invalid", "The provided credentials are invalid or an account already exists for this provider", "danger", this.$root)
                        }
                        else if(error.response.status===404){
                            toastService.showRootToast("Not found", "Provider not found", "danger", this.$root)
                        }
                        else{
                            toastService.showRootToast("Error", "An unexpected error occurred while processing your request", "danger", this.$root)
                        }
                })
            },
            search(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/provider/getFacility/${this.registration.hfid}`)
                    .then(response=>{
                        this.providers = response.data;
                        this.showResult=true;
                    })
                    .catch(error=>{
                        toastService.showRootToast("Error", "An error has occurred while processing your request", "danger", this.$root)
                    })
            },
            choiceYes(provider){
                this.selected = {
                    name: provider.name,
                    id: provider.id
                }
                this.registration.providerType = provider.type
                this.showRegistrationForm=true;
            },
            choiceNo(){
                this.showResult=false;
                this.registration.hfid='';
                this.showRegistrationForm=false;
                this.providers = [{
                    hfid: null,
                    name: null,
                    streetAddress: null,
                    city: null,
                    state: null,
                    postalCode: null,
                }]
                this.selected = {
                    name: null,
                        id: null
                }
            },
            showResendModal(){
                this.$bvModal.show('resend-modal')
            },
            hideResendModal(){
                this.$bvModal.hide('resend-modal');
            },
            resendRegistrationKey(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/provider/resendCode/${this.selected.id}`)
                    .then(response=>{
                        toastService.showRootToast("Email resent", "Registration email resent to facility's account on file", "success", this.$root)
                    })
                    .catch(error=>{
                        toastService.showRootToast("Error", "An error has occurred while processing your request", "danger", this.$root)
                    })
                    .finally(()=>{
                        this.selected =  {
                            name: null,
                            id: null
                        }
                        this.hideResendModal();
                    })
            },
        },
        validations:{
            registration:{
                hfid:{
                    required: required
                },
                registrationKey: {
                    required: required
                },
            },

        },
        created(){
          document.title="Register Provider Admin Account - NAR"
        }
    }
</script>

<style scoped>

</style>